import React, { useState } from "react";

import { Row } from "react-bootstrap";

import { useMultiFilterContext } from "contexts/MultiFilterContext";
import FilterItem from "./FilterItem";

export default function FilterGroupHiddenPart({ filterWrapper, filterGroup }) {
  const { dispatch, actions, state } = useMultiFilterContext();

  const [visible, setVisibility] = useState(false);

  return (
    <>
      {filterGroup.items.filter((n) => !n.show).length > 0 && (
        <div>
          <div
            style={{ display: visible ? "block" : "none" }}
            className="mr20 ml20"
          >
            <Row>
              {filterGroup.items
                .filter((n) => !n.show)
                .map((value, index) => {
                  return (
                    <FilterItem
                      key={index}
                      item={value}
                      size={filterWrapper.className == "column2" ? 6 : 4}
                    />
                  );
                })}
            </Row>
          </div>
          <a
            onClick={() => setVisibility(!visible)}
            className="green show-more-link"
          >
            {visible ? "Show Less" : "Show All"}
            <i
              className={`fa ml5 ${
                visible ? "fa-chevron-up" : "fa-chevron-down"
              }`}
            ></i>
          </a>
        </div>
      )}
    </>
  );
}
